import React, { FC } from 'react'

import { IconGyroscopeProps } from './IconGyroscope.types'
import * as Styled from './styles/IconGyroscope.style'

import { nonThemeableRules } from '../../ruleSet'

const IconGyroscope: FC<IconGyroscopeProps> = ({
  size = nonThemeableRules.defaultSize as number as IconGyroscopeProps['size'],
  isResponsive = false,
}: IconGyroscopeProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M28 9.09c6.163-3.885 11.52-5.208 13.82-2.91 3.553 3.555-1.545 14.412-11.385 24.25-1 1-2.02 1.957-3.035 2.86M20 38.91c-6.162 3.885-11.52 5.207-13.82 2.91-3.553-3.555 1.545-14.413 11.385-24.25a65.404 65.404 0 0 1 2.832-2.683'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M41.964 41.962c3.5-3.501-1.703-14.381-11.623-24.301C20.42 7.74 9.54 2.536 6.038 6.038c-3.501 3.5 1.703 14.38 11.623 24.301 9.92 9.92 20.8 15.124 24.302 11.623Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24 29.005a5.005 5.005 0 1 0 0-10.01 5.005 5.005 0 0 0 0 10.01Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconGyroscope
